module.exports = __webpack_public_path__ + "static/img/banner.0b51131.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/GoodsList/assets/images/banner.jpg
// module id = EXZ7
// module chunks = 11